import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormatService } from '../../../../../common/format/format.service';
import { ImageService } from '../../../../../services/image/image.service';

@Component({
  selector: 'brief-feed-invited',
  standalone: true,
  imports: [],
  templateUrl: './feed-invited.component.html',
  styleUrl: './feed-invited.component.css'
})
export class FeedInvitedComponent {

  @Input('activity') activity: any;

  @Output() viewInvitesOut = new EventEmitter<void>();

  /** Services */
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  /** Services END */

  viewInvites() {
    console.log('viewInvites()');
    if (this.activity.briefApplications.length > 0) {
      this.viewInvitesOut.emit();
    }
  }

  onCardKeydown(event: Event): void {
    const keyEvent = event as KeyboardEvent;
    if (keyEvent.key !== 'Enter' && keyEvent.key !== ' ') {
      return;
    }
    if (keyEvent.key === ' ') {
      keyEvent.preventDefault();
    }
    this.viewInvites();
  }
}
